module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAADqADAAQAAAABAAAADgAAAAC98Dn6AAAA/0lEQVQoFcWSMU/CQBiG36+5YpgcHZkguPs3xNl/wAwh6CKJS2sjzATdHFj9B8DOTsJkwm8wxt7p53eVKzb00tGvae76fu/z9i53gK8iPYB9PaU8OhDgDCyPpwKPXin/N8hMlWvcGw5LHXMLsdnhkdtHcMJNROkbHvjc9Q5gn7YgzGDMogDbwG+zBNELhrRxICHWr6ipa/ToIxNjfSeH0JWQdXYchAvRn3ETjrL+hOtIzTwA8xUMTl2SGO4Fmop+CXBH4KccsibrFab8Alg40u9Z2G04zkP/TMpBa/AAjlWy6U+QbiDx3i7n/R2tVxgle0jwRSuwPik6PF/2R8L8ALrQUh6pOUydAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/query/down.png
// module id = UH8t
// module chunks = 1